import styled from 'styled-components';

import sailorLampImage from '../../../images/sailor-lamp.png';
import { translate } from '../helpers/translate.helper';
import { Box } from '../ui/Box';

import { ErrorPageContent } from './ErrorPageContent';
import { errorPageBackgroundStyles } from './errorPageStyles';

const ResourceNotFoundBackground = styled(Box)`
    ${errorPageBackgroundStyles};
    background-image: radial-gradient(
            183.57% 78.5% at 77.44% 50%,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.25) 33.33%,
            rgba(0, 0, 0, 0.5) 66.67%,
            rgba(0, 0, 0, 0.5) 100%
        ),
        url(${sailorLampImage});
`;

export const ResourceNotFoundErrorPage = () => {
    return (
        <ResourceNotFoundBackground>
            <ErrorPageContent
                errorCode={translate('resourceNotFound.errorCode')}
                title={translate('resourceNotFound.title')}
                description={translate('resourceNotFound.description')}
            />
        </ResourceNotFoundBackground>
    );
};
